'use client'

import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { usersService } from '@/services/http/usersService'
import { DATA_TABLE_ITEMS_PER_PAGE } from '@/utils/constants'

import type { QueryParams } from '@/utils/queryParams'

type UseMyEvaluationsParams = {
  query: QueryParams
}

export const useMyEvaluations = ({ query }: UseMyEvaluationsParams) => {
  const { limit = DATA_TABLE_ITEMS_PER_PAGE, sort, page = 1, ...rest } = query
  const { toast } = useToast()

  const {
    data,
    isError,
    isLoading,
    refetch: refetchMyEvaluations,
  } = useQuery({
    queryKey: [
      'myEvaluations',
      {
        page,
        limit,
        ...(sort && {
          sort,
        }),
        ...rest,
      },
    ],
    queryFn: () =>
      usersService.getMyEvaluations({
        query: {
          page,
          limit,
          ...(sort && {
            sort,
          }),
          ...rest,
        },
      }),
  })

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Erro ao carregar suas avaliações',
        variant: 'destructive',
      })
    }
  }, [isError, toast])

  if (data) {
    const { evaluations: myEvaluations = [], pagination } = data
    return {
      myEvaluations,
      pagination,
      isLoading,
      refetchMyEvaluations,
    }
  }

  return {
    myEvaluations: [],
    pagination: {
      total: 0,
      pages: 0,
      limit,
      page,
    },
    isLoading,
    refetchMyEvaluations,
  }
}
